
<template>
    <!-- 便民查询记录表 -->
    <div class="buttonlist">
      <div class="buttonlist-m">
        <el-form
          :inline="true"
          :model="filteForm"
          class="demo-form-inline toolbar"
          style="padding-bottom: 0px"
          @submit.native.prevent
        >
          <el-form-item>
            <el-button type="warning" icon="el-icon-back" plain @click="goBack">返回</el-button>
          </el-form-item>
          <el-form-item label="项目标题">
            <el-input v-model.trim="filteForm.name" auto-complete="off" maxlength="25" class="width80"></el-input>
          </el-form-item>
          <el-form-item label="时间段">
            <el-date-picker
              v-model="filteForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              style="width: 340px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
            <el-button type="success" icon="el-icon-download" plain @click="exportRecord">导出</el-button>
          </el-form-item>
        </el-form>
        <div v-loading="loading" element-loading-text="拼命加载中......">
          <el-table
            :data="tableData"
            style="width: 100%"
            :row-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column prop="user" label="查询人" align="center"></el-table-column>
            <el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
            <el-table-column prop="idCard" label="身份证号" align="center"></el-table-column>
            <el-table-column prop="address" label="家庭住址" align="center"></el-table-column>
            <el-table-column prop="name" label="查询内容" align="center"></el-table-column>
            <el-table-column prop="creator" label="创建人" align="center"></el-table-column>
            <el-table-column prop="createdTime" label="创建时间" align="center" width="160"></el-table-column>
          </el-table>
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            layout="total, prev, pager, next"
            :total="totalDataNumber"
            :page-size="pageSize"
            align="center"
            class="fenye"
          ></el-pagination>
        </div>
      </div>
    </div>
  </template>
  <script>
  import bus from "@/vuex/eventBus";
  import { baseURL } from '@/utils/request.js';
  export default {
    data() {
      return {
        pageNum: 1,
        pageSize: 10,
        totalDataNumber: 0,
        loading: true,
        filteForm: {
          name: undefined,
          dateRange: null
        },
        tableData: [],
      };
    },
    methods: {
      goBack() {
        bus.$emit('close_current_tags');
      },
      onSubmit() {
        this.pageNum = 1;
        this.getTableData();
      },
      buildParams() {
        return {
          groupId: this.groupId,
          name: this.filteForm.name || undefined,
          startTime: this.filteForm.dateRange ? this.filteForm.dateRange[0] : undefined,
          endTime: this.filteForm.dateRange ? this.filteForm.dateRange[1] : undefined,
        };
      },
      tableRowStyle({ row, rowIndex }) {
        return rowIndex % 2 === 0 ? "background-color: #ffffff" : "background-color: #e4f5f8";
      },
      tableHeaderColor({ rowIndex }) {
        if (rowIndex === 0) {
          return "color:#2d2d2d;font-weight:600;text-align:center;font-size:16px;background-color:#d4f5fa;";
        }
      },
      getTableData() {
        let params = Object.assign({}, this.buildParams(), {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        });
        this.loading = true;
        this.$postJson('omc/convenientSearch/showRecord', params).then(res => {
          if (res.code == 200) {
            this.totalDataNumber = Number(res.result.total);
            this.tableData = res.result.list;
          }
          this.loading = false;
        });
      },
      exportRecord() {
        const params = this.buildParams();
        const groupId = this.groupId || '';
        let url = `omc/api/downConvenientSearchRecord?groupId=${groupId}`;
        if (params.name) url += `&name=${encodeURIComponent(params.name)}`;
        if (params.startTime) url += `&startTime=${encodeURIComponent(params.startTime)}`;
        if (params.endTime) url += `&endTime=${encodeURIComponent(params.endTime)}`;
        window.location.href = baseURL + url;
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.getTableData();
      },
    },
    mounted() {
      this.getTableData();
    },
    created() {
      this.groupId = sessionStorage.getItem("groupId");
    },
  };
  </script>
  <style lang="scss" scoped>
  .buttonlist {
    .buttonlist-m {
      padding: 10px 0 0 5px;
    }
  }
  .fenye {
    margin: 0;
    padding: 30px 0;
    background: #fff;
  }
  .width80 {
    width: 200px;
  }
  </style>
